import axios from 'axios';
import { apiUrl } from './ApiHost';
import authHeader from './AuthHeader';

class EmployeesService {

  getEmployees() {
    return axios.get(apiUrl + 'users', { headers: authHeader() });
  }

  addEmployee(Employee) {
    return axios.post(apiUrl + 'users', Employee, { headers: authHeader() });
  }

  updateEmployee(Employee) {
    return axios.put(apiUrl + 'users', Employee, { headers: authHeader() });
  }

  deleteEmployee(id) {
    return axios.delete(apiUrl + 'users/' + id, { headers: authHeader() });
  }
}

export default new EmployeesService();